/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Email
 *
 * 1 = SMS
 */
export enum VideoLogSendByTypes {
  Email = 1,
  SMS = 2,
}
